import * as React from "react"
import type { SVGProps } from "react"
const SvgTasks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m5.53 16.6 3.55-3.55q.3-.3.7-.28a1 1 0 0 1 .97 1 1 1 0 0 1-.28.7l-4.22 4.26q-.3.3-.7.3a1 1 0 0 1-.7-.3L2.7 16.58a1 1 0 0 1-.28-.7q0-.43.28-.7a1 1 0 0 1 .7-.28q.42 0 .7.28zm0-8 3.55-3.55q.3-.3.7-.28a1 1 0 0 1 .97 1 1 1 0 0 1-.28.7l-4.22 4.26q-.3.3-.7.3a1 1 0 0 1-.7-.3L2.7 8.58a1 1 0 0 1-.28-.7q0-.43.28-.7a1 1 0 0 1 .7-.28q.43 0 .7.28zM14 17.43a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.43.29-.71a1 1 0 0 1 .71-.29h7q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29zm0-8a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71q0-.42.29-.71a1 1 0 0 1 .71-.29h7q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgTasks
